var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('search-dialog',{attrs:{"btn-text":"顧客検索","title":"顧客検索","placeholder":"顧客ID、顧客名、またはメールアドレス","headers":_vm.headers,"item-key":"id","search-action":_vm.searchCustomerAction},on:{"onDecide":_vm.onDecide}})}
var staticRenderFns = []

export { render, staticRenderFns }